import { useMemo, useState } from 'react';
import styled from 'styled-components';

import Keyword from '../../Shared/Keyword';
import { Autocomplete } from '../../../healtheraComponents';

export default function SearchAndSelect({ options = [], value, onChange }) {
  const [inputValue, setInputValue] = useState('');

  const optionTitleById = useMemo(() => {
    return options.reduce((acc, option) => {
      acc[option.value] = option.title;
      return acc;
    }, {});
  }, [options]);

  const selectedOptions = new Set(value);
  const optionsAvailableToSelect = options.filter(
    (options) => !selectedOptions.has(options.value)
  );

  function toggleOption(optionId) {
    if (selectedOptions.has(optionId)) {
      selectedOptions.delete(optionId);
      onChange([...selectedOptions.values()]);
      return;
    }

    onChange([...selectedOptions.values(), optionId]);
  }

  return (
    <>
      <Autocomplete
        options={optionsAvailableToSelect.map(option => ({ value: option.value, label: option.title }))}
        onChange={(selected) => { toggleOption(selected.value); setInputValue(''); }}
        onInputChange={setInputValue}
        value={inputValue}
      />
      {value?.length > 0 && (
        <TagsContainer>
          {value.map((optionId) => (
            <Keyword
              keyword={optionTitleById[optionId]}
              onRemove={() => toggleOption(optionId)}
              key={optionId}
            />
          ))}
        </TagsContainer>
      )}
    </>
  );
}

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 10px;
`;
